module.exports = __webpack_public_path__ + "a69fa8be15e3dc88f88801f2d892fdf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201605_Presse_AVANGA_UJ_213KB.jpg
// module id = 569
// module chunks = 0